import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import { TableAplicacionDataSource, TableAplicacionItem } from './table-aplicacion-datasource';

@Component({
  selector: 'app-table-aplicacion',
  templateUrl: './table-aplicacion.component.html',
  styleUrls: ['./table-aplicacion.component.scss']
})
export class TableAplicacionComponent implements AfterViewInit, OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<TableAplicacionItem>;
  dataSource: TableAplicacionDataSource;

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = ['descripcion', 'modulo', 'tipo', 'activo'];

  ngOnInit() {
    this.dataSource = new TableAplicacionDataSource();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.table.dataSource = this.dataSource;
  }

  ejecutarFuncion(funcion = '') {
    alert('Thanks');
  }
}
